import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import WhiteLabelsLayer from "../components/WhiteLabelsLayer";

const WhiteLabelsPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="White Labels" />
        <WhiteLabelsLayer />
      </MasterLayout>
    </>
  );
};

export default WhiteLabelsPage;
